<div class="app-horizontal-nav-item-wrapper" [class.app-horizontal-nav-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes?.wrapper">
  @if (item.link && !item.externalLink && !item.function && !item.disabled) {
    <div
      class="app-horizontal-nav-item"
      [class.app-horizontal-nav-item-active-forced]="item.active"
      [routerLink]="[item.link]"
      routerLinkActive="app-horizontal-nav-item-active"
      [routerLinkActiveOptions]="isActiveMatchOptions"
      [matTooltip]="item.tooltip || ''">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </div>
  }
  @if (item.link && item.externalLink && !item.function && !item.disabled) {
    <a
      class="app-horizontal-nav-item"
      [href]="item.link"
      [target]="item.target || '_self'"
      [matTooltip]="item.tooltip || ''">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </a>
  }
  @if (!item.link && item.function && !item.disabled) {
    <div class="app-horizontal-nav-item" [class.app-horizontal-nav-item-active-forced]="item.active" [matTooltip]="item.tooltip || ''" (click)="item.function?.(item)">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </div>
  }
  @if (item.link && !item.externalLink && item.function && !item.disabled) {
    <div
      class="app-horizontal-nav-item"
      [class.app-horizontal-nav-item-active-forced]="item.active"
      [routerLink]="[item.link]"
      routerLinkActive="app-horizontal-nav-item-active"
      [routerLinkActiveOptions]="isActiveMatchOptions"
      [matTooltip]="item.tooltip || ''"
      (click)="item.function?.(item)">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </div>
  }
  @if (!item.link && !item.function && !item.disabled) {
    <div class="app-horizontal-nav-item" [class.app-horizontal-nav-item-active-forced]="item.active" [matTooltip]="item.tooltip || ''">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </div>
  }
  @if (item.disabled) {
    <div class="app-horizontal-nav-item app-horizontal-nav-item-disabled">
      <ng-container *ngTemplateOutlet="itemTpl"></ng-container>
    </div>
  }
</div>
<ng-template #itemTpl>
  @if (item.icon) {
    <mat-icon class="app-horizontal-nav-item-icon" [ngClass]="item.classes?.icon" [svgIcon]="item.icon"></mat-icon>
  }
  <div class="app-horizontal-nav-item-title-wrapper">
    <div class="app-horizontal-nav-item-title"><span [ngClass]="item.classes?.title">{{ item.title }}</span></div>
    @if (item.subtitle) {
      <div class="app-horizontal-nav-item-subtitle"><span [ngClass]="item.classes?.subtitle">{{ item.subtitle }}</span></div>
    }
  </div>
  @if (item.badge) {
    <div class="app-horizontal-nav-item-badge"><div class="app-horizontal-nav-item-badge-content" [ngClass]="item.badge.classes">{{ item.badge.title }}</div></div>
  }
</ng-template>
